// extracted by mini-css-extract-plugin
export default {"sc_widget":"bot-widget_sc_widget__OVnq9","sc_launcher":"bot-widget_sc_launcher__uSt2K","opened":"bot-widget_opened__+BtY-","sc_closed_icon":"bot-widget_sc_closed_icon__7+LC0"};